import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { Person } from '@mui/icons-material';

const PatientCard = ({ paciente }) => {
  return (
    <Card className="mb-4">
      <CardContent>
        <Grid container alignItems="center" spacing={2}>          
          <Grid item xs>
            <Typography variant="h6">{paciente.nombre}</Typography>
            <Grid container spacing={3}>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Edad: {paciente.edad} años
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Sexo: {paciente.sexo}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Historia Clínica: {paciente.nrHistoria}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" color="text.secondary">
                  Fecha: {paciente.fechaConsulta}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PatientCard;